<script lang="ts">
    import type {MessageSticker} from "./Types";

    export let entity: MessageSticker
</script>
{entity.sticker.emoji}
